import React from "react";
import "../serviceshowcase.css";

const ServiceShowcase = ({ sections }) => {
  return (
    <div className="custom-showcase-container">
      {/* Row 1: Two side-by-side images with center title */}
      <div className="row double-image">
        <h2 className="row-title">{sections[0].name}</h2>
        <div className="image-pair">
          <img
            src={sections[0] && sections[0].img}
            alt={sections[0] && sections[0].name}
          />
          <img
            src={sections[1] && sections[1].img}
            alt={sections[1] && sections[1].name}
          />
        </div>
      </div>

      {/* Row 2: Left text, right image */}
      <div className="row text-left-image-right">
        <div className="text-block">
          <h2>Delivering integrated BIM services to build lasting success.</h2>
          <br />
          <p>
            When you partner with the BiM builders, you not only got innovative
            BIM solutions, you get our fully vested team and a commitment to
            doing things right. Our nelentless focus on success leads to smarter
            more collaborative building practices.
          </p>
          <br />
          <p>
            <b>
              No matter how challenging you design is, when you partner with us
              you get the best BIM service in the AEC industry
            </b>
          </p>
        </div>
        <div className="image-block">
          <img
            src={sections[2] && sections[2].img}
            alt={sections[2] && sections[2].name}
          />
        </div>
      </div>

      {/* Row 3: Full-width image with center text */}
      <div className="row full-image-with-text">
        <h3>{sections[3] && sections[3].name}</h3>
        <img
          src={sections[3] && sections[3].img}
          alt={sections[3] && sections[3].name}
        />
        <p>{sections[3] && sections[3].content}</p>
      </div>

      {/* Row 4: Image left, text right */}
      <div className="row image-left-text-right">
        <div className="image-block">
          <img src={sections[4] && sections[4].img} alt={sections[4].name} />
        </div>
        <div className="text-block">
          <h3>{sections[2] && sections[2].name}</h3>
          <p>{sections[2] && sections[2].content}</p>

          <h3>{sections[3] && sections[3].name}</h3>
          <p>{sections[3] && sections[3].content}</p>

          <h3>{sections[4] && sections[4].name}</h3>
          <p>{sections[4] && sections[4].content}</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceShowcase;
